import { render, staticRenderFns } from "./G_030_JuchuToiawase_Rireki_Table.vue?vue&type=template&id=6bf2f35c&scoped=true&"
import script from "./G_030_JuchuToiawase_Rireki_Table.vue?vue&type=script&lang=ts&"
export * from "./G_030_JuchuToiawase_Rireki_Table.vue?vue&type=script&lang=ts&"
import style0 from "./G_030_JuchuToiawase_Rireki_Table.vue?vue&type=style&index=0&id=6bf2f35c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf2f35c",
  null
  
)

export default component.exports